/**
 * Get the full URL for an image path
 * In development, images are served from the backend server (localhost:5000)
 * In production, images are served from the same domain
 * 
 * @param {string} imagePath - The image path from the database (e.g., "/uploads/clubs/image.jpg")
 * @param {string} fallback - Fallback image URL if no image is provided
 * @returns {string} - The full image URL
 */
export const getImageUrl = (imagePath, fallback = 'https://via.placeholder.com/400x300?text=Board+Game+Club') => {
  // If no image path, return fallback
  if (!imagePath) {
    return fallback;
  }

  // If it's already a full URL (http:// or https://), return as is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }

  // In development, prepend the API URL
  if (process.env.NODE_ENV !== 'production') {
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
    // Remove /api suffix if present
    const baseUrl = apiUrl.replace('/api', '');
    return `${baseUrl}${imagePath}`;
  }

  // In production, the path is relative to the same domain
  return imagePath;
};

/**
 * Get the API base URL
 * @returns {string} - The API base URL
 */
export const getApiUrl = () => {
  return process.env.NODE_ENV === 'production' 
    ? '/api' 
    : (process.env.REACT_APP_API_URL || 'http://localhost:5000/api');
};
